const Auth = {
    getAuth() {
        return localStorage.getItem('token') ? true : false ;
    },
    logout() {
        return localStorage.clear();
    }
}

export default Auth;